import React from 'react';
import { Field } from 'react-final-form';

import { useIntl } from '../../../util/reactIntl';
import { createSlug } from '../../../util/urlHelpers';

import { FieldSelect } from '../../../components';

import css from './PriceVariantPicker.module.css';

const FieldHidden = props => {
  const { name, ...rest } = props;
  return (
    <Field id={name} name={name} type="hidden" className={css.hidden} {...rest}>
      {fieldRenderProps => <input {...fieldRenderProps?.input} />}
    </Field>
  );
};

const PriceVariantPicker = props => {
  const intl = useIntl();
  const { priceVariants, onPriceVariantChange, disabled } = props;
  const hasEventAndFormalVariant = priceVariants?.some(
    variant => variant?.name?.trim().toLowerCase() === 'event & formal'
  );
  const visiblePriceVariants = hasEventAndFormalVariant
    ? priceVariants.filter(variant => variant?.name?.trim().toLowerCase() !== 'formal')
    : priceVariants;
  const hasMultiplePriceVariants = visiblePriceVariants?.length > 1;
  const hasOnePriceVariant = visiblePriceVariants?.length === 1;

  return hasMultiplePriceVariants ? (
    <FieldSelect
      name="priceVariantName"
      id="priceVariant"
      className={css.priceVariantFieldSelect}
      selectClassName={css.priceVariantSelect}
      label={intl.formatMessage({ id: 'PriceVariantPicker.priceVariantLabel' })}
      onChange={onPriceVariantChange}
      disabled={disabled}
      showLabelAsDisabled={disabled}
    >
      <option disabled value="" key="unselected">
        {intl.formatMessage({ id: 'PriceVariantPicker.priceVariantUnselected' })}
      </option>
      {visiblePriceVariants.map(pv => (
        <option value={pv.name} key={pv.name} data-slug={createSlug(pv.name)}>
          {pv.name}
        </option>
      ))}
    </FieldSelect>
  ) : hasOnePriceVariant ? (
    <FieldHidden
      name="priceVariantName"
      initialValue={visiblePriceVariants[0].name}
      defaultValue={visiblePriceVariants[0].name}
    />
  ) : null;
};

export default PriceVariantPicker;
